module.exports = __webpack_public_path__ + "static/media/electric-bass-and-singing.9db755a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/pics/img/electric-bass-and-singing.jpg
// module id = 89
// module chunks = 0